"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttackedEventArgs = void 0;
const EventType_1 = require("../EventType");
class AttackedEventArgs {
    constructor(attackerId, roll, hit, crit) {
        this.attackerId = attackerId;
        this.roll = roll;
        this.hit = hit;
        this.crit = crit;
        this.__type = EventType_1.EventType.Attacked;
        this.__typeName = "Attacked";
    }
}
exports.AttackedEventArgs = AttackedEventArgs;
